export default {
    common: {
        email: 'E-Mail',
        LoginBtn: 'Sich einloggen',
        SignUpBtn: 'Registrieren',
        SubmitBtn: 'Bestätigen',
        ExitBtn: 'Verlassen',
        LogoutBtn: 'Abmelden'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'Bitte überprüfen Sie Ihre E-Mail auf den Verifizierungscode.',
        VerificationCode: 'Verifizierungscode'
    },
    header: {
        OrderHistory: 'Verlauf der Bestellungen',
        MYACCOUNT: 'MEIN KONTO',
        WelcomeBack: 'Willkommen'
    },
    detail: {
        TotalOrders: 'Gesamtanzahl der Bestellungen',
        TotalProducts: 'Gesamtanzahl der Produkte',
        WonderlandPoints: 'Wonderland-Punkte',
        APMCredits: 'APM Credits',
        ExpireOn: 'Ablaufen bei',
        NoAPMCredits: 'Keine APM-Credits',
        CreditsLoading: 'Credits laden'
    },
    panel: {},
    entry: {
        Client: 'Kunde',
        OrderDate: 'Datum der Bestellung',
        DeliverDate: 'Datum der Lieferung',
        Description: 'Beschreibung',
        Total: 'Gesamt'
    },
    board: {
        Order: 'BESTELLUNG',
        Date: 'DATUM',
        Total: 'TOTAL'
    },
    order: {
        OrderID: 'ID Bestellung',
        PurchasePlace: 'Ort',
        PurchaseDate: 'Datum der Bestellung',
        TotalPrice: 'Preis Gesamt',
    },
    product: {
        Name: 'Name',
        SKU: 'SKU',
        Size: 'Größe',
        Quantity: 'Menge',
        Price: 'Preis',
        WarrantyUntil: 'Garantie bis',
    }
}


// WEBPACK FOOTER //
// ./src/locales/ge/index.js